var React = require('react');

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"68.6","height":"68.6","style":{"fill":"none"},"key":0}),React.createElement("path",{"d":"M34.3,68.6A34.3,34.3,0,1,1,68.6,34.3,34.3,34.3,0,0,1,34.3,68.6ZM34.3,3a31.3,31.3,0,1,0,31.3,31.3h0A31.33,31.33,0,0,0,34.3,3Z","key":1}),React.createElement("path",{"d":"M29.38,56.59h-.05a1.5,1.5,0,0,1-1.1-.54L16.41,41.84a1.5,1.5,0,0,1,0-2l3.28-3.72a1.5,1.5,0,0,1,1.91-.29l7.84,4.76L53.38,20.9a1.51,1.51,0,0,1,2,.06l3.5,3.29a1.49,1.49,0,0,1,.47,1.05,1.54,1.54,0,0,1-.41,1.08L30.47,56.12A1.5,1.5,0,0,1,29.38,56.59ZM19.54,40.91l9.92,11.93L55.7,25.4l-1.43-1.35L30.56,43.63a1.49,1.49,0,0,1-1.74.12l-7.68-4.66Z","key":2})]);
}

Icon.displayName = "Icon";

Icon.defaultProps = {"viewBox":"0 0 68.6 68.6"};

module.exports = Icon;

Icon.default = Icon;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js?name=Icon!./src/components/icons/homeowners-icon-check-outline.svg
// module id = 295
// module chunks = 0